import { testimonials } from '@/mocks/manhua';

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <i
          key={star}
          className={`text-sm ${star <= rating ? 'ri-star-fill text-amber-500' : 'ri-star-line text-foreground-300'}`}
        ></i>
      ))}
    </div>
  );
}

export default function TestimonialSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs text-foreground-500 uppercase tracking-wider">读者评价</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            读者真实
            <br />
            口碑评价
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            来自全国各地漫画爱好者的真实反馈，韩漫网收获了无数好评
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <article key={t.id} className="bg-background-50 rounded-xl p-5">
              <StarRating rating={t.rating} />
              <h3 className="mt-3 text-base font-semibold text-foreground-900">{t.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{t.content}</p>
              <div className="mt-4 flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-9 h-9 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-foreground-500">
            已有 <strong className="text-primary-600 font-semibold">超过50万</strong> 读者加入韩漫网
          </p>
        </div>
      </div>
    </section>
  );
}